var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45552 29.7945C6.16154 30.4923 4.93865 29.3387 5.23727 27.4588L6.65922 19.2412L0.686997 13.2026C-0.393692 12.0917 -0.237277 10.4254 1.42642 10.1548L9.81597 8.88724L13.4562 1.12537C13.5614 0.798446 13.7675 0.513376 14.0447 0.311159C14.3219 0.108943 14.6561 0 14.999 0C15.342 0 15.6761 0.108943 15.9533 0.311159C16.2305 0.513376 16.4366 0.798446 16.5418 1.12537L20.1963 8.88724L28.5147 10.1548C30.2353 10.4254 30.4059 12.0917 29.311 13.2026L23.4099 19.2412L24.7608 27.4588C25.0736 29.3387 23.8365 30.4923 22.5567 29.7802L15.0061 25.6358L7.45552 29.7945Z",
    fill: "#CB34FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.3f3c9890a91e1b866af808bbfa66dffe.svg";
export { ForwardRef as ReactComponent };